(function () {
  function initReadMore() {
    var sections = document.querySelectorAll('[id$="__rich_text_rhMfqN"]');
    sections.forEach(function (section) {
      var textEl = section.querySelector('.rich-text__text');
      if (!textEl || textEl.dataset.readMoreInit) return;
      textEl.dataset.readMoreInit = 'true';
      textEl.classList.add('js-read-more-collapsed');
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'read-more-toggle';
      toggle.textContent = 'Read more';
      textEl.insertAdjacentElement('afterend', toggle);
      toggle.addEventListener('click', function () {
        var collapsed = textEl.classList.toggle('js-read-more-collapsed');
        toggle.textContent = collapsed ? 'Read more' : 'Read less';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initReadMore);
  document.addEventListener('shopify:section:load', initReadMore);
})();
